import HubPage from '../../components/HubPage';
export default function OperationsHub() { return <HubPage hubKey="operations" />; }
